import * as React from "react";

import "./update-amount-form.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

import {MoneyInput2} from "./money-input-2";

export const UpdateAmountForm = ({onChange, disabled = false}) => cs(
    ["amount", (_, next) => UseState({next})],
    ({amount}) => (
        <div className="update-amount-form update-amount-form-4dm">
            <div className="label" xd-qa-type="label" xd-qa-name="Set all to">
                Set all to
            </div>

            <i className="fa fa-circle-dollar" xd-qa-type="icon" xd-qa-name="Dollar"/>

            {MoneyInput2({
                state: amount,
                style: {
                    height: 26,
                },
                placeholder: "Amount",
            })}

            <button {...{
                disabled: isNaN(amount.value) || disabled,
                onClick: () => onChange(amount.value),
                
            }}
                xd-qa-type="button"
                xd-qa-name="Update"
            >UPDATE</button>
        </div>
    )
);
